import { ModalPortal } from "@livechat/design-system-react-components";

import ConfirmActionModal from "components/modals/ConfirmActionModal";
import { StackingContextLevel } from "styles/stacking-context-level";

interface IProps {
  onClose(): void;
  onSubmit(): void;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const DeleteTicketModal = ({ onSubmit, onClose }: IProps) => {
  return (
    <ModalPortal zIndex={StackingContextLevel.Modal}>
      <ConfirmActionModal
        onClose={onClose}
        heading="Delete ticket?"
        primaryAction={{
          label: "Delete forever",
          onClick: onSubmit,
          actionType: "destructive",
          dataTestId: "delete-modal-button",
        }}
        secondaryAction={{
          label: "Cancel",
          onClick: onClose,
        }}
      >
        You&apos;re about to delete a ticket forever, and it cannot be undone. Are you sure you want to delete it?
      </ConfirmActionModal>
    </ModalPortal>
  );
};
